import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/legal';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="garantia-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-124" data-mp="223ofbjucs0ef">
      <div className="mx-auto max-w-4xl px-6" data-id="element-125" data-mp="1x28pzfl577q8">
        <Reveal data-id="element-126" data-mp="19dzdj49tjwbr">
          <div className="rounded-3xl border border-mint-200 bg-mint-50 px-8 py-12 text-center sm:px-14" data-id="element-127" data-mp="19fiu6vze09e2">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-mint-600 text-white" data-id="element-128" data-mp="14h8vwcid8so8">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-129" data-mp="1j6n6fnxohg57" />
            </span>
            <h2 id="garantia-title" className="mt-6 font-display text-3xl text-ink sm:text-4xl" data-id="element-130" data-mp="1ecixx08rl020">
              Garantía de 7 días
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-131" data-mp="lpohcef2iktt">
              Revisa los 6 tomos y los 5 bonos. Si en los 7 días siguientes a tu
              compra el material no es lo que esperabas, escríbenos a{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-mint-700 underline underline-offset-4 hover:text-mint-800" data-id="element-132" data-mp="tx1nykd4y81w">
                {SUPPORT_EMAIL}
              </a>{' '}
              y{' '}
              <strong className="font-semibold text-ink" data-id="element-133" data-mp="12t0tw1gv0hdl">te devolvemos el importe</strong>.
            </p>
            <p className="mx-auto mt-6 max-w-lg text-[15px] leading-relaxed text-ink-muted" data-id="element-134" data-mp="6309sfrfqp2m">
              Consulta los detalles en la{' '}
              <Link to="/legal/desistimiento" className="font-medium text-mint-700 underline underline-offset-4 hover:text-mint-800" data-id="element-135" data-mp="f12h1d1ridyc">
                política de desistimiento y reembolsos
              </Link>
              .
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}